export default "__VITE_PUBLIC_ASSET__61264ef4__"